import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { createPortal } from 'react-dom';

import Icons from 'Component/Icons';

import TypographyHeader from '../TypographyHeader';

import './SideDrawer.style';

/** @namespace Advox/Component/SideDrawer/Component */
export class SideDrawer extends PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        closeDrawer: PropTypes.func.isRequired,
        isOpen: PropTypes.bool.isRequired,
    };

    render() {
        const { title, closeDrawer, isOpen, children } = this.props;

        return createPortal(
            <div block="SideDrawer" mods={{ visible: isOpen }} onClick={closeDrawer}>
                <div
                    block="SideDrawer"
                    elem="Drawer"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <div block="SideDrawer" elem="TopBar">
                        <div block="SideDrawer" elem="Title">
                            <TypographyHeader variant="medium">{title}</TypographyHeader>
                        </div>
                        <div block="SideDrawer" elem="Close" onClick={closeDrawer}>
                            <Icons name="close" width="30" height="30" fill="#000" />
                        </div>
                    </div>
                    <div block="SideDrawer" elem="Content">
                        {children}
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default SideDrawer;
